import { render, staticRenderFns } from "./BankMandateListProvider.vue?vue&type=template&id=d77eca40&scoped=true&"
import script from "./BankMandateListProvider.vue?vue&type=script&lang=ts&"
export * from "./BankMandateListProvider.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d77eca40",
  null
  
)

export default component.exports